import NotificationButton from './NotificationButton';

const DashboardHeader = ({ user, onToggleSidebar }) => {
  return (
    <nav className="navbar navbar-light bg-light shadow-sm fixed-top p-2">
      <div className="container-fluid d-flex justify-content-between align-items-center">

        {/* Botón hamburguesa */}
        <button
          className="btn btn-outline-secondary d-md-none me-2"
          type="button"
          onClick={onToggleSidebar}
          aria-label="Toggle navigation"
        >
          <i className="fas fa-bars"></i>
        </button>


        <div className="d-flex align-items-center">
          <img
            src={user?.photoUrl || 'https://via.placeholder.com/40'}
            alt="Usuario"
            className="rounded-circle me-2"
            width="40"
            height="40"
          />
          <span className="fw-bold">{user?.name || 'Usuario'}</span>
        </div>

        <NotificationButton />
      </div>
    </nav>
  );
};

export default DashboardHeader;
